<template>
    <div></div>
    <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 20 22"
        fill="none"
        class="size"
    >
        <path
            d="M11.6177 20.367C11.1841 20.773 10.6044 21 10.0011 21C9.39785 21 8.81818 20.773 8.38449 20.367C4.41302 16.626 -0.909237 12.4469 1.68627 6.37966C3.08963 3.09916 6.45834 1 10.0011 1C13.5439 1 16.9126 3.09916 18.316 6.37966C20.9082 12.4393 15.599 16.6389 11.6177 20.367Z"
            stroke="currentColor"
            stroke-width="1.5"
        />
        <path
            d="M13.5 10C13.5 11.933 11.933 13.5 10 13.5C8.067 13.5 6.5 11.933 6.5 10C6.5 8.067 8.067 6.5 10 6.5C11.933 6.5 13.5 8.067 13.5 10Z"
            stroke="currentColor"
            stroke-width="1.5"
        />
    </svg>
</template>

<script>
export default {
    name: "LocationIcon",
};
</script>
<style lang="scss" scoped>
.size {
    width: 12px;
    height: 12px;
    @media (min-width: $screen-m) {
        width: 16px;
        height: 16px;
    }
    @media (min-width: $screen-l) {
        width: 18px;
        height: 20px;
    }
}
</style>
